module.exports = __webpack_public_path__ + "media/images/training-5c079a42f0e1ce897affb0b1967b95ac.png";